import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

// Generischer Ja/Nein-Bestätigungsdialog – anders als z.B.
// DialogCancelUserComponent (user/components/dialog-cancel-user) bewusst
// nicht an ein Feature gebunden und übersetzungsfrei: Titel/Text/Button-
// Beschriftungen kommen bereits fertig übersetzt über MAT_DIALOG_DATA rein
// (Aufrufer nutzt dafür TranslateService.instant()), damit diese Komponente
// von jeder Stelle in der App wiederverwendbar bleibt.
export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  // Für irreversible/destruktive Aktionen (z.B. "Einsatz abschließen") –
  // roter statt neutraler Bestätigen-Button, siehe confirm-dialog.
  // component.scss.
  danger?: boolean;
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  imports: [CommonModule, MatDialogModule, MatButtonModule, CdkScrollable],
})
export class ConfirmDialogComponent {
  data: ConfirmDialogData = inject(MAT_DIALOG_DATA);
}
